import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux/es';

import moment from 'moment';
import Swal from 'sweetalert2';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Stack from 'react-bootstrap/Stack';
import { Form } from 'react-bootstrap';
import { useUiStore } from '../hooks/useUiStore';
import { addAction, getAllActions } from '../../store/ai2';
import { ActionLog } from './Insights/components/ActionLog';

import fullscreenEnter from '../../assets/img/fullscreen-enter.png';
import pinkBellIcon from '../../assets/img/pinkBell.png';
import purpleBellIcon from '../../assets/img/purpleBell.png';

import './offCanvas.scss';
import { useLocation } from 'react-router-dom';

export const ActionOffCanvas = () => {
  const [actionStatus, setActionStatus] = useState(null);
  const [actionTitle, setActionTitle] = useState('');
  const [textareaValue, setTextareaValue] = useState('');
  const [selectedClinician, setSelectedClinician] = useState('');
  function handleClinicianSelection(value) {
    setActionStatus('R');
    setSelectedClinician(value);
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');

  const actionOptions = [
    'Face-to-face clinic',
    'Phone contact',
    'Face-to-face home visit',
    'Provider interaction',
    'Carer interaction',
    'Other',
  ];

  const { actions } = useSelector((state) => state.actions);
  const isLoading = useSelector((state) => state.patientProfile.loading);
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const clinician_clinics = useSelector(
    (state) => state.clinicianProfile.clinics,
  );
  const { clinicianId } = useSelector((state) => state.clinicianProfile);

  const patient_clinics = useSelector(
    (state) => state.patientProfile.patientProfile.clinics,
  );

  // Off Canvas state from ui store
  const { isInsightDetailsOpen, insightDetailsContent, closeInsightDetails } =
    useUiStore();
  let item = 0;
  if (insightDetailsContent.user_action_id) {
    item = actions.find(
      (action) => action.id == insightDetailsContent.user_action_id,
    );
  }

  useEffect(() => {
    if (item) {
      setSelectedClinician(item.access_token);
      setActionTitle(item.description);
    }
  }, [item]);
  const onCloseInsightDetails = () => {
    // close Off Canvas
    closeInsightDetails();
  };

  const viewAllInsights = () => {
    // close Off Canvas
    window.location.href = '#2';
    window.location.reload();
  };

  function handleTextareaChange(value) {
    setTextareaValue(value);
  }

  function handleActionTitleChange(value) {
    setActionTitle(value);
  }

  let patientClinicsIds = new Set();
  if (!isLoading && patient_clinics) {
    patientClinicsIds = new Set(
      Object.values(patient_clinics).map((clinic) => clinic.id),
    );
  }

  const filteredClinicianClinics = Object.keys(clinician_clinics)
    .filter((key) => patientClinicsIds.has(clinician_clinics[key].clinic_id))
    .reduce((result, key) => {
      result[key] = clinician_clinics[key];
      return result;
    }, {});
  const combinedClinicians = Object.values(filteredClinicianClinics).reduce(
    (acc, clinicObj) => acc.concat(clinicObj.caremapprClinicians),
    [],
  );

  const uniqueIds = new Set();

  const uniqueClinicians = combinedClinicians.filter((clinician) => {
    if (!uniqueIds.has(clinician.access_token)) {
      uniqueIds.add(clinician.access_token);
      return true;
    }
    return false;
  });

  const dispatch = useDispatch();

  const handleActionSubmit = async (actionId, action_status) => {
    if (!selectedClinician || !actionTitle) {
      Swal.fire({
        icon: 'warning',
        text: 'Select a clinician and a title for the action',
        showConfirmButton: true,
      });
      return;
    }

    // Form data to submit
    const formData = {
      access_token: access_token,
      actionId: actionId,
      description: actionTitle,
      reason: action_status === null ? 'Set to Ongoing' : textareaValue,
      action_status: action_status,
      who_was_assigned: selectedClinician,
    };

    // Here you can dispatch the form data to your store or send it to the server as needed
    await dispatch(await addAction(formData, selectedTenancy));
    await dispatch(await getAllActions(access_token, selectedTenancy));

    Swal.fire({
      icon: 'success',
      text: 'Action has been saved',
      showConfirmButton: true,
    });
    onCloseInsightDetails();
  };

  // if Off Canvas is open
  if (isInsightDetailsOpen) {
    return (
      <>
        <Offcanvas
          show={isInsightDetailsOpen}
          onHide={onCloseInsightDetails}
          placement="end"
          backdrop={false}
          scroll={true}
          className={
            'action-border ' +
            (item.clinician_id === clinicianId ? 'pink' : 'purple')
          }
        >
          <Offcanvas.Header>
            <button
              type="button"
              className="btn-close me-auto"
              aria-label="Close"
              onClick={onCloseInsightDetails}
            ></button>
            <button className="btn btnPrimary btn-sm" onClick={viewAllInsights}>
              View all actions
              <img
                style={{ paddingLeft: '10px', paddingRight: '5px' }}
                alt=""
                src={fullscreenEnter}
              />
            </button>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <h2 className="offcanvas-title">
              <div id="why_created" className="action-name">
                {item.clinician_id === clinicianId && (
                  <img
                    className="bell-icon"
                    style={{ width: 17, height: 17, margin: 5 }}
                    src={pinkBellIcon}
                    alt="pink bell"
                  ></img>
                )}
                {item.clinician_id !== clinicianId && (
                  <img
                    className="bell-icon"
                    style={{ width: 17, height: 17, margin: 5 }}
                    src={purpleBellIcon}
                    alt="purple bell"
                  ></img>
                )}
                <select
                  value={actionTitle || item.description}
                  onChange={(e) => {
                    handleActionTitleChange(e.target.value);
                  }}
                >
                  <option>{item.description}</option>
                  {actionOptions.map((option, idx) => (
                    <option key={idx} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </h2>

            <div className="offcanvas-inner">
              <div className="group">
                <div>
                  <div className="status">
                    {item.action_status === 'E' ||
                    item.action_status === 'A' ||
                    item.action_status === 'D' ||
                    item.action_status === 'C' ||
                    item.action_status === 'S'
                      ? 'Closed'
                      : item.action_status === null ||
                          item.action_status === 'R'
                        ? 'Ongoing'
                        : item.action_status === 'I'
                          ? 'Ignored'
                          : 'no data'}
                  </div>
                  <div className="date">
                    {item.created_at
                      ? moment(new Date(item.created_at)).format(
                          'DD MMM YYYY',
                        ) + ' - '
                      : ''}
                    {item.action_status === 'C' && item.ended_at
                      ? moment(new Date(item.ended_at)).format('DD MMM YYYY')
                      : ''}
                  </div>
                </div>
                {/* <div className="title"> {item.why_created}</div> */}

                <div className="title">{/*<SummaryLog item={item} />*/}</div>
              </div>

              <div className="group">
                <ActionLog item={item} key={item.id} short={true}></ActionLog>
              </div>
              <div className="flexItem">
                <Form id="actionForm">
                  <div id="txt3" className="flexVert divSelect">
                    <div className="flexVertWrap mb-4">
                      <label
                        className="txtLeft txtDropdownLabel"
                        style={{ whiteSpace: 'normal', marginTop: 20 }}
                      >
                        Assigned to:
                      </label>
                      <Form.Select
                        id={'clinicianOptions'}
                        className={'insightSelect'}
                        value={selectedClinician || '-Select-'}
                        onChange={(e) =>
                          handleClinicianSelection(e.target.value)
                        }
                      >
                        <option value="-Select-" disabled>
                          -Select a Clinician-
                        </option>
                        {uniqueClinicians.map((clinician, index) => (
                          <option key={index} value={clinician.access_token}>
                            {`${clinician.first_name} ${clinician.last_name}`}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                    <div className="flexVertWrap mb-4">
                      <label
                        className="txtLeft txtDropdownLabel"
                        style={{ whiteSpace: 'normal' }}
                      >
                        Action update
                      </label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        id="insightReasonTextbox"
                        name="actionUpdate"
                        value={textareaValue || ''}
                        onChange={(e) => {
                          handleTextareaChange(e.target.value);
                        }}
                        placeholder="Enter action update..."
                      />
                    </div>
                  </div>
                </Form>
              </div>

              <div className="group" style={{ marginBottom: 5 }}>
                <Stack direction="horizontal" gap={2}>
                  <button
                    style={{ marginRight: 15 }}
                    type="button"
                    className="btn btnSecondary btn-xs btn-long ms-auto"
                    onClick={() => handleActionSubmit(item.id, 'C')}
                  >
                    Complete Action
                  </button>

                  <button
                    type="button"
                    className="btn btnPrimary btn-xs btn-long"
                    onClick={() => handleActionSubmit(item.id, actionStatus)}
                  >
                    Save
                  </button>
                </Stack>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  } else return null;
};
